import { Component, Input, OnInit, OnChanges, AfterViewInit, ElementRef } from '@angular/core';

declare let $: any;
@Component({
  selector: 'si-info-popover',
  templateUrl: './info-popover.component.html',
  styleUrls: ['./info-popover.component.scss']
})
export class InfoPopoverComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() config: object;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {

  }
  ngOnChanges(changes) {

  }
  ngAfterViewInit() {
    const self = this;
    if ($.fn.popover) {
      $(self.elementRef.nativeElement).find('#' + self.config['id']).popover({
        html: true,
        container: '.' + self.config['htmlContainer'],
        content: function () {
          return $('#' + self.config['dataContainerID']).html();
        },
        delay: { show: 100, hide: 0 }
      });
    }

  }
}
